import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'eu',
    fullName: 'Basque',
    nativeName: 'Euskara',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Zerbait Harrigarria Badator",
    landing_subtitle: "ArgVoid aplikazioak eta jokoak garatzeko estudioa da. Egon adi, laster gauza berriak datoz!",
    select_language: "Hautatu Hizkuntza",
    search_placeholder: "Bilatu hizkuntzak...",
    terms_title: "Zerbitzu-baldintzak",
    policy_title: "Pribatutasun politika",
    cookies_title: "Cookie politika",
    terms_content: `
        <strong>1. Baldintzak onartzea</strong><br>
        ArgVoid-era sartzean, Zerbitzu-baldintza hauek onartzen dira. Baldintza hauek onartzen ez badira, zerbitzua ez da erabili behar.<br><br>

        <strong>2. Plataformaren erabilera</strong><br>
        ArgVoid eta bere aplikazioak "dagoen moduan" ematen dira informazio- eta sormen-helburuetarako. Zerbitzua legezko helburuetarako soilik erabili behar da.<br><br>

        <strong>3. Jokabide debekatua</strong><br>
        Guztiz debekatuta dago guneko ahultasunak ustiatzea, spam-a egitea edo azpiegiturara baimenik gabe sartzen saiatzea.<br><br>

        <strong>4. Lege-oharra</strong><br>
        Plataforma eta zerbitzuak edozein unetan alda daitezke jakinarazi gabe. Ez da zerbitzuaren erabilgarritasunari edo erabilgarritasunari buruzko bermerik ematen.
    `,
    policy_content: `
        <strong>1. Informazio Bilduma</strong><br>
        Plataformak ez du erabiltzaile autentifikaziorik edo konturik sortu behar momentu honetan. Ez da aktiboki biltzen bisitariengandik identifikatzeko informazio pertsonalik (adibidez, izenak edo helbide elektronikoak).<br><br>

        <strong>2. Erabilera-datuak</strong><br>
        Oinarrizko analisi anonimoak bil daitezke guneko trafikoa ulertzeko eta aplikazioak hobetzeko. Datu hauek ez daude lotuta erabiltzaile indibidualen identitateekin.<br><br>

        <strong>3. Hirugarrenen Zerbitzuak</strong><br>
        Hirugarrenen hornitzaileak erabil daitezke ostalaritza eta analisi zerbitzuetarako. Hornitzaile horien pribatutasun-praktikek beren azpiegituran prozesatutako datu anonimoak arautzen dituzte.<br><br>

        <strong>4. Datuen segurtasuna</strong><br>
        Plataforma babesteko zentzuzko segurtasun neurriak ezartzen dira. Hala ere, Internet bidez transmititzeko metodorik ez da guztiz segurua.<br><br>
    `,
    cookies_content: `
        <strong>1. Zer dira cookieak eta tokiko biltegiratzea?</strong><br>
        Cookieak eta arakatzailearen tokiko biltegiratzea gailuan gordetako datu-fitxategi txikiak dira bisitetan konfigurazio-hobespenak gogoratzeko.<br><br>

        <strong>2. Erabilera Xedea</strong><br>
        Arakatzailea LocalStorage zorrozki konfigurazio-ezarpenak gordetzeko erabiltzen da, adibidez:<br>
        - Hizkuntza-hobespenak<br>
        - Erabiltzailearen interfazearen konfigurazioa (adibidez, diseinua edo gaiaren ezarpenak)<br>
        - Aldi baterako aplikazioaren cache<br><br>

        <strong>3. Jarraipenik ez </strong><br>
        Cookieak eta tokiko biltegiratzea ez dira erabiltzen publizitate edo hirugarrenen jarraipena egiteko. Biltegiratutako datu guztiak plataformaren oinarrizko funtzionalitaterako dira zorrozki.<br><br>

        <strong>4. Kontrola</strong><br>
        Arakatzailearen datuak edozein unetan garbitu daitezke arakatzailearen ezarpenen bidez, eta horrek tokiko konfigurazio guztiak berrezarriko ditu.
    `,
    cookie_consent_text: "Oinarrizko cookieak erabiltzen ditugu webguneak behar bezala funtzionatzen duela ziurtatzeko, hala nola, zure saioa aktibo mantentzea, hizkuntza-hobespena gordetzea eta beste konfigurazio pertsonalizatuak.",
    read_policy: "Irakurri Cookie politika",
    support_title: "Jarri harremanetan laguntzarekin",
    support_subject_label: "Gaia",
    support_message_label: "Mezua",
    support_submit_button: "Bidali mezua",
    support_hint: "Oharra: honek zure posta elektronikoko aplikazio lehenetsia irekiko du mezua bidaltzeko.",
    support_success_msg: "Zure posta elektronikoko aplikazioa irekitzen...",
    support_error_msg: "Ezin izan da mezua bidali. Saiatu berriro geroago.",
    explorer_title: "Esploratzailea",
    history_title: "Historia",
    animation_title: "Animazioa",
    config_title: "Konfigurazioa",
    tool_mouse: "Hautatu (Ktrl+M)",
    tool_brush: "Eskuila (Ktrl+B)",
    tool_brush_mode: "Aldatu modua (Sendo/Garbitu)",
    tool_eraser: "Bormagoma (Ktrl+E)",
    tool_brush_size: "Doitu eskuila tamaina",
    tool_bucket: "Bete (Ktrl+F)",
    tool_eyedropper: "Konttatakoa",
    tool_grid: "Sareta (Ktrl+Maius+B)",
    tool_rotate: "Biratu (Ktrl+Maius+R)",
    tool_flip_h: "Irauli H (Ktrl+Maius+H)",
    tool_flip_v: "Irauli V (Ktrl+Maius+V)",
    tool_transpose: "Transposizioa (Ktrl+Maius+T)",
    label_width: "Zabalera",
    label_height: "Altuera",
    label_frames: "Fotograma kopurua",
    label_animation: "Animazio Estiloa",
    label_background_color: "Atzeko planoaren kolorea",
    label_interval: "Tartea",
    tool_anim_config: "Animazio-konfigurazioa",
    label_new_width: "Zabalera berria",
    label_new_height: "Altuera Berria",
    label_apply: "Aplikatu",
    label_colors: "Koloreak",
    label_size: "Tamaina",
    label_tolerance: "Tolerantzia",
    val_horizontal: "Horizontala",
    val_vertical: "Bertikala",
    val_sequence: "Sekuentzia",
    val_bounce: "Errebotea",
    val_random: "Ausazko",
    val_solid: "Solidoa",
    val_clear: "Garbi",
    action_add_sheet: "Fitxa berria",
    action_import: "Inportatu",
    action_export: "Esportatu",
    action_sort_projects: "Ordenatu",
    sort_date_old: "Zaharrena Lehen",
    sort_date_new: "Berriena Lehenengoa",
    sort_name_az: "Izena (A-Z)",
    sort_name_za: "Izena (Z-A)",
    action_new_sprite: "Sprite berria",
    action_new_project: "Proiektu Berria",
    modal_save_all_title: "Gorde aldaketa guztiak",
    modal_save_all_desc: "Hautatu gorde beharreko aktiboak:",
    modal_save_selected: "Gorde hautatua",
    action_saved: "Gordetuta",
    modal_create_sprite_title: "Sortu Sprite berria",
    modal_create_project_title: "Sortu Proiektu Berria",
    modal_add_sheet_title: "Gehitu orri berria",
    modal_rename_sheet_title: "Aldatu orria",
    modal_rename_sprite_title: "Aldatu Sprite izena",
    modal_delete_sprite_title: "Ezabatu Sprite",
    modal_delete_project_title: "Ezabatu proiektua",
    modal_delete_sheet_title: "Ezabatu orria",
    placeholder_sprite_name: "Izena",
    placeholder_project_name: "Izena",
    placeholder_sheet_name: "Izena",
    placeholder_new_name: "Izen berria",
    action_create: "Sortu",
    action_add: "Gehitu",
    action_rename: "Aldatu izena",
    action_duplicate: "Bikoiztu",
    action_delete: "Ezabatu",
    action_cancel: "Utzi",
    confirm_delete_sprite: "Ziur sprite hau ezabatu nahi duzula?",
    confirm_delete_project: "Ziur proiektu hau ezabatu nahi duzula? Sprite guztiak kenduko dira.",
    confirm_delete_sheet: "Ziur orri hau ezabatu nahi duzula?",
    err_select_sprite: "Mesedez, hautatu sprite bat lehenik.",
    err_select_project: "Mesedez, hautatu proiektu bat lehenik.",
    err_name_empty: "Izena ezin da hutsik egon.",
    err_sprite_exists: "Izen hori duen sprite bat existitzen da dagoeneko.",
    err_project_exists: "Izen hori duen proiektu bat badago jada.",
    err_no_content: "Ez dago gorde beharreko edukirik.",
    err_no_changes: "Ez dago aldaketarik gordetzeko.",
    err_delete_last_sheet: "Ezin da azken orria ezabatu.",
    err_extract_frames: "Ezin izan da fotogramarik atera.",
    err_indexeddb: "Ezin izan da gorde lokalean. Baliteke zure arakatzaileak ez onartzea IndexedDB.",
    msg_upload_success: "Kargatu ondo: {0}",
    msg_upload_failed: "Ezin izan da kargatu: {0}",
    msg_save_success: "Gorde arrakastatsua.",
    msg_saving: "Gordetzen...",
    msg_multi_save_result: "{0} erreproduzitu gorde dira. {1} hutsegite.",
    menu_title: "Menua",
    menu_save: "Gorde",
    menu_save_all: "Gorde guztiak",
    menu_support: "Jarri harremanetan laguntzarekin",
    label_local_storage: "Tokiko biltegiratzea",
    label_sign_in: "Hasi saioa",
    modal_export_title: "Esportatu Sprite",
    label_filename: "Fitxategiaren izena",
    label_format: "Formatua",
    action_export_confirm: "Esportatu",
};

export default translations;
